export enum LabourCostMethod {
  UnionPrice = 1,
  InstallationTime = 2,
  NoInstallationCosts = 3,
}
